export default __webpack_public_path__ + "static/media/Hanmoto.82322f9d.jpg";